import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "certificate-list" }
const _hoisted_2 = {
  key: 0,
  class: "cert-container"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "cert-content" }
const _hoisted_5 = { class: "cert-name" }
const _hoisted_6 = { class: "cert-hint" }
const _hoisted_7 = { class: "cert-hint" }
const _hoisted_8 = {
  key: 1,
  class: "empty-certs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.certificates.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (cert) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cert.thumb,
              class: _normalizeClass(["certificate", { 
          'selected': _ctx.selectedThumb === cert.thumb,
          'invalid': !cert.isValid 
        }]),
              onClick: ($event: any) => (_ctx.selectCertificate(cert))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getCertificateName(cert.cn)), 1),
                _createElementVNode("div", _hoisted_6, "Действует до: " + _toDisplayString(_ctx.formatDate(cert.validToDate)), 1),
                _createElementVNode("div", _hoisted_7, " ИНН: " + _toDisplayString(_ctx.getInn(cert.cn)) + ", " + _toDisplayString(_ctx.getOgrnType(cert.cn)) + ": " + _toDisplayString(_ctx.getOgrn(cert.cn)), 1)
              ])
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "empty-image" }, [
            _createElementVNode("img", {
              width: "200px",
              src: "/images/icons/mascote/slon_facepalm.png",
              alt: "No certificates"
            })
          ], -1),
          _createElementVNode("div", { class: "empty-message" }, "Нет доступных сертификатов", -1)
        ])))
  ]))
}